<template>
    <div>
        <header>
            <date-range-picker ref="datepicker" @selected="setCreatePeriodFilter" style="width: 470px; margin-bottom: 15px;"/>
        </header>

        <v-table id="appointmentsTable"
                 request-uri="onlineAppointments/getAppointmentsList"
                 pagesize="50"
                 :lazycount="true"
                 ref="table"
                 @clear-table-filter="clearPlaceholder">
            <template v-slot:header>
                <v-tr>
                    <v-th name="city" width="45">
                        Город
                    </v-th>
                    <v-th name="medflex_id" sort="medflex_id" width="100">
                        №
                    </v-th>
                    <v-th name="created_at" sort="created_at" width="80">
                        Созд
                    </v-th>
                    <v-th name="clinic" sort="clinic" minwidth="200">
                        Клиника
                    </v-th>
                    <v-th name="patient" sort="patient" minwidth="200">
                        Пациент
                    </v-th>
                    <v-th name="phone" sort="phone" width="120">
                        Тел. пациента
                    </v-th>
                    <v-th name="doctor" sort="doctor" minwidth="200">
                        Врач
                    </v-th>
                    <v-th name="date" sort="date" width="150">
                        Прием
                    </v-th>
                    <v-th name="status" sort="status" width="150">
                        Статус
                    </v-th>
                    <v-th name="error_text" sort="error_text" width="200">
                        Ошибка
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="city" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                                ...cityOptions
                            ]'
                        ></v-select>
                    </v-th>
                    <v-th name="medflex_id" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker
                            :format="'YYYY-MM-DD'"
                            v-model="filter.value"
                            ref="singleDate"
                            @change="clearDateRangePicker"
                        />
                    </v-th>
                    <v-th name="clinic" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="patient" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="phone" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="doctor" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="date" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="status" v-slot="{ filter }">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                    ...v_s_convert(statuses)
                                ]'
                        ></v-select>
                    </v-th>
                    <v-th name="error_text" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover" :id="'oa-tr-' + item.id">
                    <v-td name="city" highlight="*">
                        <span v-if="item.medflexClinic.clinic !== null" v-tooltip="item.medflexClinic.clinic.cityObj.name">
                            {{ item.medflexClinic.clinic.cityObj.name_info.short }}
                        </span>
                    </v-td>
                    <v-td name="medflex_id">
                        {{ item.medflex_id }}
                    </v-td>
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                    <v-td name="clinic">
                        <b>{{ item.medflexClinic.clinic_name }}</b>
                        <template v-if="item.medflexClinic.address">
                            <br>
                            <span>{{ item.medflexClinic.address }}</span>
                        </template>
                    </v-td>
                    <v-td name="patient">
                        <span>{{ item.fullName }}</span>
                    </v-td>
                    <v-td name="phone">
                        <span>{{ item.phone }}</span>
                    </v-td>
                    <v-td name="doctor">
                        <span>{{ item.medflexDoctor.name }}</span>
                    </v-td>
                    <v-td name="date" highlight="*">
                        {{ item.date | formatDate }} в {{ item.time_start }}
                    </v-td>
                    <v-td name="status" highlight="*" align="center">
                        <span>{{ statuses[item.status] }}</span>
                    </v-td>
                    <v-td name="error_text">
                        <span>{{ item.error_text }}</span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </div>
</template>

<script>
export default {
    props: {
        cityOptions: {
            type: Array,
            required: true
        },
    },
    data: function () {
        return {
            disableUpdateBtn: false,
            statuses: {
                '': '',
                'SUCCESS': 'Успешно',
                'ERROR': 'Ошибка',
            },
        };
    },
    methods: {
        setCreatePeriodFilter(data) {
            if (this.$refs?.table !== undefined) {
                if (data) {
                    this.$refs.table.$data.filter.createdPeriod = data;
                    if (this.$refs.singleDate) {
                        this.$refs.singleDate.$refs.popup.clear();
                    }
                } else {
                    delete this.$refs.table.$data.filter.createdPeriod;
                }
                this.$refs.table.update();
            }
        },
        clearPlaceholder() {
            this.$refs.datepicker.clearRange()
            this.clinicFilterName = '';
        },
        clearDateRangePicker() {
            if (this.$refs.singleDate.date && this.$refs.datepicker.end) {
                delete this.$refs.datepicker.clearRange();
            }
        },
    }
}
</script>

<style>
#appointmentsTable {
    height: calc(100vh - 185px);
}
</style>
